import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { PrimengModule } from './primeng.module';
import { NgxLoadingModule, ngxLoadingAnimationTypes } from 'ngx-loading';

import {RippleModule} from "primeng/ripple";
import { StepsComponent } from './components/step/step.component';
import { ActividadNegocioDialogComponent } from './components/actividad-negocio-dialog/actividad-negocio-dialog.component';
import { DropdownComponent } from './components/dropdown/dropdown.component';
import { ActividadNegocioDialogService } from './components/actividad-negocio-dialog/actividad-negocio-dialog.service';
import { BankDialogComponent } from './components/bank-dialog/bank-dialog.component';
import { BankDialogService } from './components/bank-dialog/bank-dialog.service';
import { AsesorDialogComponent } from './components/asesor-dialog/asesor-dialog.component';
import { AsesorDialogService } from './components/asesor-dialog/asesor-dialog.service';
import { CountdownTimerComponent } from './components/countdown-timer/countdown-timer.component';
import { LoadingComponent } from './components/loading/loading.component';
import { OtpInputComponent } from './components/otp-input/otp-input.component';
import { NgOtpInputModule } from  'ng-otp-input';
import { ErrorPageComponent } from './components/error-page/error-page.component';
import { ProvinciaDialogComponent } from './components/provincia-dialog/provincia-dialog.component';
import { ProvinciaDialogService } from './components/provincia-dialog/provincia-dialog.service';
import { CiudadDialogComponent } from './components/ciudad/ciudad-dialog.component';
import { CiudadDialogService } from './components/ciudad/ciudad-dialog.service';
import { LoadingAbsoluteComponent } from './components/loading-absolute/loading-absolute.component';
import { alertComponent } from './components/alert/alert.component';
import { FileUploadComponent } from './components/file-upload/file-upload.component';
import { FileUploadMappingService } from './components/file-upload/file-upload.mapping.service';
import { FileUploadService } from './components/file-upload/file-upload.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    PrimengModule,
    RippleModule,
    NgxLoadingModule.forRoot({
      animationType: ngxLoadingAnimationTypes.threeBounce,
      backdropBackgroundColour: 'rgba(0,0,0,0.5)',
      backdropBorderRadius: '4px',
      tertiaryColour: '#1976d2',
      fullScreenBackdrop: true,
    }),
    NgOtpInputModule
  ],
  declarations: [
    LoadingComponent,
    LoadingAbsoluteComponent,
    OtpInputComponent,
    StepsComponent,
    DropdownComponent,
    ActividadNegocioDialogComponent,
    BankDialogComponent,
    AsesorDialogComponent,
    ProvinciaDialogComponent,
    CiudadDialogComponent,
    CountdownTimerComponent,
    alertComponent,
    ErrorPageComponent,
    FileUploadComponent
  ],
  exports: [
    LoadingComponent,
    LoadingAbsoluteComponent,
    OtpInputComponent,
    PrimengModule,
    CommonModule,
    StepsComponent,
    DropdownComponent,
    ActividadNegocioDialogComponent,
    BankDialogComponent,
    AsesorDialogComponent,
    ProvinciaDialogComponent,
    CiudadDialogComponent,
    FormsModule,
    ReactiveFormsModule,
    CountdownTimerComponent,
    alertComponent,
    ErrorPageComponent,
    FileUploadComponent,
    NgxLoadingModule,
  ],
  providers: [
    ActividadNegocioDialogService,
    BankDialogService,
    AsesorDialogService,
    ProvinciaDialogService,
    CiudadDialogService,
    FileUploadMappingService,
    FileUploadService
  ]
})
export class SharedModule { }
